import { StocksImportContainer } from '@/modules/ProductsImport';

const StocksImport = (): JSX.Element => <StocksImportContainer />;

export default StocksImport;
